import { useMutation } from 'react-query'
import { type ResearcherPersistence } from '../../../../types/persistence/researcher-persistence'
import { api } from '../../../api'

const updateResearcher = async (id: number, data: ResearcherPersistence) => {
  const response = await api.put(`/researchers/${id}`, data)
  return response.data
}

export const useResearcherEditMutation = () => {
  return useMutation('update-researcher', {
    mutationFn: ({ id, data }: { id: number, data: ResearcherPersistence }) => {
      return updateResearcher(id, data)
    },
  })
}
